<template>
  <div style="min-height: 750px">
    <div class="group_1">
      <div class="box_1">
        <div class="box_left">
          <div style="height: 92px"
               v-if="classShow">
            <div class="subjects"
                 v-if="!isDropdownOpen">
              <div class="text_4">当前培训科目</div>
              <div class="dropdown">
                <div class="subText">{{ subInfo.trainingSubject }}</div>
                <div class="qh"
                     @click="toggleDropdown">
                  <img src="../../../assets/images/Group 2020@2x.png"
                       alt="" />
                  <div class="km">切换科目</div>
                </div>
              </div>
            </div>
            <div class="subjects2"
                 v-if="isDropdownOpen">
              <div class="text_4">当前培训科目</div>
              <div class="sub">
                <div class="dropdown">
                  <div class="subText"
                       style="color: #3172f6">
                    {{ subInfo.trainingSubject }}
                  </div>
                  <div class="qh"
                       @click="toggleDropdown">
                    <img src="../../../assets/images/Group 2020@2x.png"
                         alt="" />
                    <div class="km">切换科目</div>
                  </div>
                </div>
                <div class="dropdown_item"
                     v-if="dropdownList.length > 0">
                  <div class="subItem"
                       v-for="item in dropdownList"
                       :key="item.id"
                       @click="handleKm(item.trainingSubjectId)">
                    {{ item.trainingSubject || '' }}
                  </div>
                </div>
                <div class="dropdown_item"
                     v-else>
                  <div class="subItem"
                       style="color: #999; font-size: 14px">暂无更多科目~</div>
                </div>
              </div>
            </div>
          </div>

          <div class="subjects"
               v-else>
            <div class="text_4">当前培训科目</div>
            <div class="dropdown"
                 style="width: 150px">
              <div class=""
                   @click="handleClass">
                <div class="km"
                     style="color: #3172f6">暂无科目，去报名</div>
              </div>
            </div>
          </div>
          <div class="count">
            <div class="count_1">
              <span class="cicle"></span>
              <div class="count_text">已报名培训科目： <span style="color: #FF634D ;">{{subInfo.classCount||0}}</span>个</div>
            </div>

            <div class="count_1"> <span class="cicle"></span>
              <div class="count_text">已完成学习培训科目：<span style="color:#FF634D  ;">{{subInfo.finishClassCount||0}}</span>个</div>
            </div>
          </div>
          <!-- <div class="gn">
            <div class="text_20">常用功能</div>
            <div style="display: flex; margin-top: 8px">
              <div class="noteBtn" @click="getNote">通知中心</div>
              <div class="orderBtn" @click="getOrder">订单管理</div>
            </div>
          </div> -->
        </div>
        <div class="box_right">
          <div class="time"
               v-if="classShow">
            <div class="time_1">
              开通时间：<span style="color: #333"
                    v-if="subInfo.auditTime != null && subInfo.auditTime != ''">{{
                subInfo.auditTime || ''
              }}</span>
            </div>
            <div class="time_1">
              剩余时间：<span style="color: #333"
                    v-if="subInfo.daysToExpire != null && subInfo.daysToExpire != ''">{{ subInfo.daysToExpire || '' }}天</span>
            </div>
          </div>
          <!-- 图标 -->
          <div style="display: flex; width: 370px; justify-content: space-between">
            <div class="chart-container">
              <div id="targetChart"
                   class="chart"></div>
            </div>
            <div class="chart-container">
              <div id="completedChart"
                   class="chart"></div>
            </div>
            <div class="chart-container">
              <div id="progressChart"
                   class="chart"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box_2">
        <div class="kjlist"
             @click="goPush(1)">
          <img src="../../../assets/images/Group 2008@2x.png"
               alt="" />
          <div class="text_1">题库练习</div>
        </div>
        <div class="kjlist"
             @click="goPush(2)">
          <img src="../../../assets/images/Group 2009@2x.png"
               alt="" />
          <div class="text_1">模拟考试</div>
        </div>
        <div class="kjlist"
             @click="getNote">
          <img src="../../../assets/images/Group 2007@2x.png"
               alt="" />
          <div class="text_1">通知中心</div>
        </div>

        <div class="kjlist"
             style="margin-top: 16px"
             @click="gotoClass">
          <img src="../../../assets/images/Group 2005@2x.png"
               alt="" />
          <div class="text_1">实训班信息</div>
        </div>
        <div class="kjlist"
             style="margin-top: 16px"
             @click="getUserInfo">
          <img src="../../../assets/images/Group 2004@2x.png"
               alt="" />
          <div class="text_1">个人信息</div>
        </div>
        <div class="kjlist"
             style="margin-top: 16px"
             @click="goPush(3)">
          <img src="../../../assets/images/Group 2006@2x.png"
               alt="" />
          <div class="text_1">错题库</div>
        </div>
      </div>
    </div>
    <div class="group_2">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="理论学习"
                     name="first">
          <div v-if="userCourseList.length > 0">
            <div style="display: flex; flex-wrap: wrap">
              <div class="studyList"
                   v-for="item in userCourseList"
                   :key="item.id"
                   @click="handleChapter(item)"
                   :class="{'active': currentActiveCourseId === item.courseId}">
                <div class="studyTitle">{{ item.courseName }}</div>
                <div class="hours">{{ item.ccreditHour }}学时</div>
                <div class="tag"
                     style="color: #888; background: #e9e9e9"
                     v-if="item.studyStatus == '03'">已完成</div>
                <div class="tag"
                     v-if="item.studyStatus == '01'">未学习</div>
                <div class="tag"
                     v-if="item.studyStatus == '02'">学习中</div>
              </div>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 20px">
              <el-pagination @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"
                             :current-page="pageNum"
                             :page-sizes="[12, 24, 48, 100]"
                             :page-size="pageSize"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="total">
              </el-pagination>
            </div>
          </div>
          <div v-else
               style="display: flex; align-items: center; justify-content: center; height: 450px; flex-direction: column">
            <img src="../../../assets/images/image 61@2x (1).png"
                 alt=""
                 style="width: 180px; height: 180px" />
            <div style="font-weight: 400; font-size: 14px; color: #999999">
              暂未报名课程，立即<span style="color: #3172f6; cursor: pointer"
                    @click="handleClass">前往报名</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="实训班信息"
                     name="second">
          <div v-if="offlineClassInfoVoList.length > 0">
            <div class="classList"
                 v-for="v in offlineClassInfoVoList"
                 :key="v.offlineClassId">
              <div class="cover">
                <img :src="v.classImage"
                     alt=""
                     v-if="v.classImage != '' && v.classImage != null" />
                <img src="../../../assets/images/textImgs.png"
                     alt=""
                     v-else />
                <div class="classText">{{ v.className }}</div>
              </div>
              <div class="info">
                <div class="infoText_1">
                  {{ v.className }}
                </div>
                <div class="infoText_2">
                  <span style="width: 142px; display: inline-block">报名时间：{{ v.auditTime }}</span><span style="margin-left: 40px">实训班联系电话：{{ v.phone }}</span>
                </div>
                <div class="infoText_2">培训地址：{{ v.offlineClassSite }}</div>
              </div>
              <div class="btn"
                   @click="handleDetil(v)">课程详情</div>
            </div>
          </div>
          <div v-else
               style="display: flex; align-items: center; justify-content: center; height: 450px; flex-direction: column">
            <img src="../../../assets/images/image 61@2x (1).png"
                 alt=""
                 style="width: 180px; height: 180px" />
            <div style="font-weight: 400; font-size: 14px; color: #999999">
              暂未报名课程，立即<span style="color: #3172f6; cursor: pointer"
                    @click="handleClass">前往报名</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- //章节信息 -->
    <div class="group_5"
         v-if="showChapter">
      <el-tabs v-model="activeName1">
        <el-tab-pane label="知识点课程"
                     name="first1">
          <div style="display: flex; flex-wrap: wrap">
            <div class="chapterList"
                 v-for="h in getCourseinfo"
                 :key="h.chapterId"
                 @click="handleVide(h.cwId)">
              <div class="chapterCover">
                <div class="chapterTitle">{{ h.chapterTitle }}</div>
              </div>
              <div class="chapterBox">
                <div class="chtext">{{ h.chapterTitle }}</div>
                <div class="chtext_1"
                     v-if="h.studyStatus == '01'">未学习</div>
                <div class="chtext_1"
                     v-if="h.studyStatus == '03'">已完成</div>
                <div class="chtext_1"
                     v-if="h.studyStatus == '02'">学习中</div>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <el-pagination @size-change="handleSizeChange1"
                           @current-change="handleCurrentChange1"
                           :current-page="pageNum1"
                           :page-sizes="[10, 20, 40, 100]"
                           :page-size="pageSize1"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total1">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 课程详情 -->
    <el-dialog :visible.sync="centerDialogVisible"
               width="40%"
               center>
      <img :src="pic"
           alt=""
           style="width: 100%" />
    </el-dialog>
    <NoticeDialog :visible.sync="dialogTableVisible" />
  </div>
</template>
<script>
import NoticeDialog from '../../component/NoticeDialog.vue';
import { getClassLearnInfo, getResChapterList } from '../../../api/study';
import { healthScreenshot, healthCertificate } from '@/api/pay.js';
// 引入echart
import * as echarts from 'echarts';

export default {
  components: {
    NoticeDialog
  },
  data() {
    return {
      activeName: 'first',
      dialogTableVisible: false,
      trainSubjectId: '',
      pageNum: 1,
      activeName1: 'first1',
      pageSize: 12,
      subInfo: {}, //科目信息
      classShow: false, //是否有课
      isCourseUpdate: '', //01 表示课程没更新 02 表示课程有更新
      isDropdownOpen: false,
      dropdownList: [], //下拉科目
      offlineClassInfoVoList: [], //实训班级
      userCourseList: [], //理论学习
      total: 0,
      centerDialogVisible: false,
      pic: '', //课程图片详情
      classCreditHour: 0, //目标学时
      finishCredit: 0, //完成学时
      completionRate: 0, //学习进度
      showChapter: false, //是否展示章节
      pageNum1: 1,
      pageSize1: 10,
      total1: 0,
      getCourseinfo: [],
      currentCourseId: '',
      onlineClassId: '',
      cassid: '',
      courseId: '',
      currentActiveCourseId: null
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getCourse(this.$route.query.trainSubjectId);
    window.scrollTo(0, 0);
  },
  methods: {
    //去通知中心
    getNote() {
      this.dialogTableVisible = true;
    },
    //去订单管理
    getOrder() {
      this.$emit('update:tabIndex', 3);
    },
    //去个人信息
    getUserInfo() {
      this.$emit('update:tabIndex', 4);
    },
    //去课程学习
    getClass() {
      this.$emit('update:tabIndex', 8);
    },
    //去报名
    handleClass() {
      this.$router.push({ path: '/courseSelection' });
    },
    // 切换下拉菜单
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    //查看实训班
    gotoClass() {
      this.activeName = 'second';
    },
    //课程详情
    handleDetil(v) {
      this.pic = v.offlineCourse;
      this.centerDialogVisible = true;
    },
    //切换科目
    handleKm(id) {
      this.trainSubjectId = id;
      this.getCourse(id);
      this.isDropdownOpen = !this.isDropdownOpen;
      this.showChapter = false;
    },
    //分页事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getCourse(this.trainSubjectId);
    },
    //页码变化事件
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCourse(this.trainSubjectId);
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNum1 = 1;
      getResChapterList({
        courseId: this.currentCourseId,
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        classId: this.onlineClassId
      }).then(res => {
        this.getCourseinfo = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    // //快捷通道
    // goPush(type) {
    //   if (type == 1) {
    //     this.$emit('update:tabIndex', 7);
    //   } else if (type == 2) {
    //     this.$emit('update:tabIndex', 10);
    //   } else {
    //     this.$router.push({ path: '/errorExam' });
    //   }
    // },
    // 快捷通道：改为页面跳转（新开页面或当前页跳转）
    goPush(type) {
      switch (type) {
        case 1:
          // 题库练习
          //  window.open(this.$router.resolve({ path: '/studyMain?tabIndex=7' }).href, '_blank');
          this.$emit('update:tabIndex', 7);
          break;
        case 2:
          // 模拟考试
          this.$emit('update:tabIndex', 10);
          // window.open(this.$router.resolve({ path: '/studyMain?tabIndex=10' }).href, '_blank');
          break;
        case 3:
        default:
          // 错题库
          window.open(this.$router.resolve({ path: '/errorExam' }).href, '_blank');
          break;
      }
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val;
      getResChapterList({
        courseId: this.currentCourseId,
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        classId: this.onlineClassId
      }).then(res => {
        this.getCourseinfo = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    //获取报名课程信息
    getCourse(id) {
      getClassLearnInfo({
        trainSubjectId: id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res.data.data && res.data.data != '0') {
          this.classShow = true;
          this.subInfo = res.data.data;
          this.dropdownList = res.data.data.trainingSubjectList || [];
          this.offlineClassInfoVoList = res.data.data.offlineClassInfoVoList;
          this.total = res.data.data.userCourseList.total;
          this.userCourseList = res.data.data.userCourseList.rows;
          this.isCourseUpdate = res.data.data.isCourseUpdate;
          this.classCreditHour = res.data.data.classCreditHour;
          this.finishCredit = res.data.data.finishCredit;
          this.completionRate = res.data.data.completionRate;
          res.data.data.trainingSubjectList.forEach(v => {
            healthScreenshot({ userId: res.data.data.userId, orderId: v.orderId }).then(res => {
              console.log(res);
            });
            healthCertificate({ userId: res.data.data.userId, orderId: v.orderId }).then(res => {
              console.log(res);
            });
          });

          if (this.isCourseUpdate == '02') {
            this.$alert('您的班级课程有更新，请及时查看学习！', '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
          }
          // 更新图表数据
          this.$nextTick(() => {
            this.initTargetChart();
            this.initCompletedChart();
            this.initProgressChart();
          });
        }
      });
    },
    //去看视频页面
    handleVide(item) {
      this.$router.push({ path: '/video', query: { cwId: item, classId: this.cassid, courseId: this.courseId,trainSubjectId:this.trainSubjectId } });
    },
    // 目标学时
    initTargetChart() {
      const value = this.classCreditHour || 0;
      const max = value === 0 ? 1 : value; // 防止除零

      const myChart = echarts.init(document.getElementById('targetChart'));
      const option = {
        series: [
          {
            type: 'gauge',
            radius: '90%',
            startAngle: 360,
            endAngle: 0,
            max: max,
            pointer: { show: false },
            progress: {
              show: true,
              roundCap: true,
              width: 8,
              itemStyle: { color: '#3172F6' }
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [[1, '#d2e2fe']]
              }
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            detail: {
              offsetCenter: [0, 0],
              valueAnimation: true,
              formatter: () => `{title|目标学时}\n{value|${value}}`,
              rich: {
                title: { fontFamily: 'PingFang SC', fontWeight: 'normal', fontSize: 12, color: '#999999', lineHeight: 18 },
                value: { fontFamily: 'PingFang SC', fontWeight: 'Bold', fontSize: 18, color: '#333333', lineHeight: 12 }
              }
            },
            data: [{ value: value }]
          }
        ]
      };
      myChart.setOption(option);
    },
    // 完成学时
    initCompletedChart() {
      const target = this.classCreditHour || 1; // 避免除零
      const value = this.finishCredit || 0;

      const myChart = echarts.init(document.getElementById('completedChart'));
      const option = {
        series: [
          {
            type: 'gauge',
            radius: '90%',
            startAngle: 360,
            endAngle: 0,
            max: target, // 关键：以目标学时为最大值
            pointer: { show: false },
            progress: {
              show: true,
              roundCap: true,
              width: 8,
              itemStyle: { color: '#3172F6' }
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [[1, '#d2e2fe']]
              }
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            detail: {
              offsetCenter: [0, 0],
              valueAnimation: true,
              formatter: () => `{title|完成学时}\n{value|${value}}`,
              rich: {
                title: { fontFamily: 'PingFang SC', fontWeight: 'normal', fontSize: 12, color: '#999999', lineHeight: 18 },
                value: { fontFamily: 'PingFang SC', fontWeight: 'Bold', fontSize: 18, color: '#333333', lineHeight: 12 }
              }
            },
            data: [{ value: value }]
          }
        ]
      };
      myChart.setOption(option);
    },
    // 学习进度
    initProgressChart() {
      const myChart = echarts.init(document.getElementById('progressChart'));
      const option = {
        series: [
          {
            type: 'gauge',
            radius: '90%',
            startAngle: 360,
            endAngle: 0,
            pointer: { show: false },
            progress: {
              show: true,
              roundCap: true,
              width: 8,
              itemStyle: { color: '#3172F6' }
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [[1, '#d2e2fe']]
              }
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            detail: {
              offsetCenter: [0, 0],
              valueAnimation: true,
              formatter: value => `{title|学习进度}\n{value|${value}%}`,
              rich: {
                title: {
                  fontFamily: 'PingFang SC',
                  fontWeight: 'normal',
                  fontSize: 12,
                  color: '#999999',
                  lineHeight: 18
                },
                value: {
                  fontFamily: 'PingFang SC',
                  fontWeight: 'Bold',
                  fontSize: 18,
                  color: '#333333',
                  lineHeight: 12
                }
              }
            },
            data: [{ value: this.completionRate || 0 }]
          }
        ]
      };
      myChart.setOption(option);
    },
    //章节信息
    handleChapter(item) {
      this.pageNum1 = 1;
      this.currentActiveCourseId = item.courseId;
      this.showChapter = true;
      this.currentCourseId = item.courseId;
      this.onlineClassId = this.subInfo.onlineClassId;
      getResChapterList({ courseId: item.courseId, pageNum: this.pageNum1, pageSize: this.pageSize1, classId: this.onlineClassId }).then(
        res => {
          this.getCourseinfo = res.data.rows;
          this.cassid = res.data.data.classId;
          this.courseId = res.data.data.courseId;
          this.total1 = res.data.total;
        }
      );
      setTimeout(() => {
        this.$nextTick(() => {
          window.scrollBy({
            top: 900,
            behavior: 'smooth'
          });
        });
      }, 300);
    },

    handleClick() {
      this.showChapter = false;
    }
  },

  mounted() {
    this.initTargetChart();
    this.initCompletedChart();
    this.initProgressChart();
  },
  beforeCreate() {},
  beforeMount() {}
};
</script>
<style lang="less" scoped>
.group_1 {
  display: flex;
  width: 1188px;
  height: 190px;
  margin-bottom: 12px;
  .box_1 {
    display: flex;
    width: 919px;
    height: 190px;
    background: linear-gradient(177deg, #d8e7ff 0%, #e7f1ff 60.91%, #ffffff 100%);
    border-radius: 4px 4px 4px 4px;
    padding: 17px 20px;
    margin-right: 12px;
    .text_20 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
    .box_left {
      width: 494px;
      border-right: 1px solid #eeeeee;
      position: relative;
      .subjects {
        .text_4 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
        }
        .dropdown {
          width: 440px;
          height: 48px;
          background: rgba(49, 114, 246, 0.1);
          border-radius: 4px 4px 4px 4px;
          padding: 11px 12px;
          margin-top: 8px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          justify-content: space-between;
          .subText {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .qh {
          width: 108px;
          height: 38px;
          background: #3172f6;
          border-radius: 4px 4px 4px 4px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 16px;
            margin-right: 2px;
            height: 16px;
          }
        }
        .km {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .box_right {
      width: 425px;
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      display: flex;
      flex-direction: column;
      .time {
        margin-left: 35px;
        width: 400px;
        display: flex;
        // justify-content: space-around;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        .time_1 {
          width: 165px;
          margin-right: 50px;
        }
      }
      .chart-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        .chart {
          width: 90px;
          height: 90px;
        }

        .chart-label {
          margin-top: 8px;
          font-size: 12px;
          color: #666;
        }
      }
    }
    .subjects2 {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99999;
      .text_4 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
      }
      .dropdown {
        // background: #f4f6fa;
        border-radius: 4px 4px 4px 4px;
        // border: 1px solid #f4f6fa;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 999;
      }
      .sub {
        margin-top: 8px;
        padding: 11px 12px;
        width: 440px;
        background: #d0e2fe;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px 4px 4px 4px;
      }
      .subText {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .qh {
        width: 108px;
        height: 38px;
        background: #3172f6;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 16px;
          margin-right: 2px;
          height: 16px;
        }
      }
      .km {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      .subItem {
        margin-bottom: 16px;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
      }
      .dropdown_item {
        margin-top: 16px;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .noteBtn {
      width: 100px;
      height: 36px;
      background: rgba(255, 0, 0, 0.1);
      border-radius: 4px 4px 4px 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ff0000;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }
    .orderBtn {
      cursor: pointer;
      width: 100px;
      height: 36px;
      background: rgba(255, 121, 0, 0.1);
      border-radius: 4px 4px 4px 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
      margin-left: 16px;
      color: #ff7900;
    }
  }
  .box_2 {
    padding: 20px 26px;
    width: 257px;
    height: 190px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    flex-wrap: wrap;
    .kjlist:nth-child(3n) {
      margin-right: 0 !important;
    }
    .kjlist {
      width: 60px;
      margin-right: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      img {
        width: 44px;
        height: 44px;
      }
      .text_1 {
        margin-top: 6px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
      }
    }
  }
}
.group_2 {
  width: 1188px;
  background: hsl(0, 0%, 100%);
  // min-height: 547px;
  border-radius: 4px 4px 4px 4px;
  padding: 20px 24px;
  .studyList:nth-child(4n) {
    margin-right: 0 !important;
  }
  .tag {
    width: 68px;
    height: 28px;
    background: rgba(124, 167, 255, 0.2);
    border-radius: 14px 0px 4px 0px;
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: center;
    line-height: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3172f6;
  }
  .studyList {
    position: relative;
    margin-right: 20px;
    width: 270px;
    height: 80px;
    background: #f2f6ff;
    border-radius: 4px 4px 4px 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .studyTitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hours {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin-top: 10px;
  }
  .classList {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    .cover {
      position: relative;
      .classText {
        position: absolute;
        top: 30px;
        left: 0;
        padding: 0px 10px;
        width: 120px;
        height: 96px;
        font-size: 14px;
        text-align: center;
      }
    }
    .cover img {
      width: 120px;
      height: 96px;
      border-radius: 4px 4px 4px 4px;
    }
    .info {
      width: 900px;
      margin-left: 12px;
    }
    .btn {
      width: 101px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #707070;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }
    .infoText_1 {
      margin-top: 7px;
      width: 700px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
    .infoText_2 {
      width: 600px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 12px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
}
.group_5 {
  margin-top: 12px;
  padding: 20px 24px;
  width: 1188px;
  height: auto;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  .chapterList:nth-child(5n) {
    margin-right: 0 !important;
  }
  .chapterList {
    width: 220px;
    margin-right: 10px;
    margin-bottom: 20px;
    height: 167px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
    .chapterCover {
      width: 220px;
      height: 100px;
      background-image: url('../../../assets/images/chapterBg.png');
      background-size: 100%;
      border-radius: 4px 0px 0px 4px;
      padding: 28px 15px;
      .chapterTitle {
        width: 115px;
        height: 44px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        display: -webkit-box; /* 使用弹性盒模型 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
        overflow: hidden;
      }
    }
    .chapterBox {
      padding: 10px;
      .chtext {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 8px;
      }
      .chtext_1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
::v-deep {
  .el-tabs__item {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
  }
}
* {
  outline: none !important;
  -webkit-tap-highlight-color: transparent;
}
.count {
  display: flex;
  width: 440px;
  height: 48px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  justify-content: space-around;
  line-height: 48px;

  .cicle {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: rgba(49, 114, 246, 0.4);
    border-radius: 50%;
    margin-right: 9px;
  }
  .count_1 {
    display: flex;
    align-items: center;
  }
  .count_text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #8d8d8d;
  }
}
.active {
  background: #3172f6 !important;
  color: #ffffff !important;

  .tag,
  .studyTitle,
  .hours {
    color: #ffffff;
  }
  .tag {
    background: rgba(255,255,255,0.4) !important;
     color: #ffffff !important;
  }
}
</style>
